module.exports = __webpack_public_path__ + "img/outdoorCurtainDetector.e12d104d.webp";